import validators from '../../utils/validators';
import CheckupField from '@/models/checkup/field';

class CheckupItem {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      title: (v) => validators.isNotEmptyString(v),
      type: (v) => validators.isNotEmptyStringOrNull(v),
      multiple: (v) => validators.isBoolean(v),
      sort: (v) => validators.isNumber(v),
      catalog: (v) => validators.isNotEmptyStringOrNull(v),
      description: (v) => validators.isNotEmptyStringOrNull(v),
      fields: (v) => validators.isArray(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid CheckupItem property '${property}' in ${data.id}`);
      }

      if (property === 'fields') {
        this.fields = [];

        for (const field of data[property]) {
          this.fields.push(new CheckupField(field));
        }
      } else {
        this[property] = data[property];
      }
    }
  }
}

export default CheckupItem;
